import { Point } from "appworks/utils/geom/point";
import { logger } from "appworks/utils/logger";
import { BitmapText as PIXIBitmapText, Renderer } from "pixi.js";
import { RenderOrientation } from "./render-orientation";
import { TextPosition } from "./text-position";

export class BitmapText extends PIXIBitmapText {

    // These currency codes have full stops or other common bitmap font characters in, which would mean that
    // these codes show up incorrectly (due to half characters being missing).
    // These should be removed entirely if found.
    //                                             ISK, PEN, CHF, CHF, LRD, RUB, LBP, OMR, QAR, SYP
    public static mixedCurrencyCodes: string[] = ["kr.", "S/. ", "SFr.", "Fr.", "L$", "р.", "ل.ل", "ر.ق", "ر.ع.", "£S"];

    public landscape: TextPosition = new TextPosition();
    public portrait: TextPosition = new TextPosition();

    public autoShrink: boolean = true;

    public boundsWidth: number;
    public boundsHeight: number;

    private lastPosition: TextPosition;

    private scaling: boolean;

    public setVisible(visible: boolean): void {
        this.visible = visible;
    }

    public setText(text: string): void {
        this.text = text;
    }

    public setAutoResize(autoresize: boolean): void {
        this.autoShrink = autoresize;
    }

    public updateTransform() {
        const position = this.getOrientationPosition();

        if (!position.equals(this.lastPosition)) {
            this.fontSize = position.fontSize;
        }

        if (!position.equals(this.lastPosition) || this.dirty) {
            this.lastPosition = position.clone();
            this.resizeBounds(position.width, position.height, this.fontSize);
            this.updateText();
            this.move(position.x, position.y, position.scale, position.align);

            super.scale.x = position.scale.x;
            super.scale.y = position.scale.y;
        }

        super.updateTransform();
    }

    public _render(renderer: Renderer) {
        if (this.getOrientationPosition().unavailable) {
            return;
        }

        return super._render(renderer);
    }

    public move(x: number, y: number, scale: { x: number, y: number }, align: string) {
        this.x = x;
        this.y = y;

        let anchor;

        // Alignment
        if (align === "center") {
            anchor = new Point(0.5, 0.5);
        } else if (align === "right") {
            anchor = new Point(1, 0.5);
        } else {
            anchor = new Point(0, 0.5);
        }

        this.x += (this.boundsWidth - this.textWidth * scale.x) * anchor.x;
        this.y += (this.boundsHeight - this.textHeight * scale.y) * anchor.y;
    }

    public resizeBounds(width: number, height: number, fontSize: number) {
        this.boundsWidth = width;
        this.boundsHeight = height;

        this.fontSize = fontSize;
    }

    public render(renderer: Renderer) {
        if (this.scaling) {
            return;
        }

        this.removeMixedCurrencies();

        super.render(renderer);

        if (this.autoShrink) {
            this.scaleToFit();
        }
    }

    private scaleToFit() {
        this.scaling = true;
        while (this.textWidth > this.boundsWidth && this.fontSize > 1) {
            this.fontSize--;
            super.updateText();
        }

        const position = this.getOrientationPosition();
        if (position.fontSize !== this.fontSize) {
            this.move(position.x, position.y, position.scale, position.align);
        }

        this.scaling = false;
    }

    private removeMixedCurrencies() {
        // const font = this.font as { name?: string; size?: number; };
        // const fontName = font.name;

        // const data = BitmapText.fonts[fontName];

        // let hasAllCharacters: boolean = true;

        // let charCode;
        // let charData;
        // for (let i: number = 0; i < this.text.length; i++) {
        //     charCode = this.text.charCodeAt(i);
        //     charData = data.chars[charCode];

        //     if (!charData) {
        //         hasAllCharacters = false;
        //     }
        // }

        // if (!hasAllCharacters) {
        //     BitmapText.mixedCurrencyCodes.forEach((currencyCode: string) => {
        //         if (this.text.indexOf(currencyCode) > -1) {
        //             this.text = this.text.replace(currencyCode, "");
        //         }
        //     });
        // }
    }

    private getOrientationPosition() {
        return RenderOrientation.isLandscape() ? this.landscape : this.portrait;
    }
}
